import React, { useState } from "react";
import { PrimaryButton, Dialog, DialogFooter } from '@fluentui/react';
import { renderUser } from "../../../helpers/HelperMethods";
import { PowerAppChangeTaskType } from "../../../GlobalConst/globalEnums";

const DeletePowerAppConfirmationDialog = ({powerApp, onDialogClosed}) => {

    const [showDialog, setShowDialog] = useState(true)

    const deletionTask = powerApp.changeTasks.find(x => x.type === PowerAppChangeTaskType.delete)

    const closeDialog = () => {
        setShowDialog(false)
        onDialogClosed();
    }

    const requestSavedDialog = 
        <Dialog 
            hidden={!showDialog}
            maxWidth={600}
            dialogContentProps={{
                title: `Deletion Request Saved`,
            }}
            modalProps={{
                isBlocking: false
            }}
            onDismiss={closeDialog}
        >
            <div>
                {
                    deletionTask && deletionTask.approver
                    ? <div>
                        <div>A deletion approval has been sent to the environment owner ({renderUser(deletionTask.approver)})</div>
                        <div>Unless the environment owner rejects the request, the element will be deleted.</div>
                        <div>You will receive a notification when a decision is taken.</div>
                    </div>
                    : <div>
                        <div>
                            The element has been successfully deleted. 
                        </div>
                        <div>
                            It will be backed up for 6 months and can be recovered by the environment owner through Provisioner if needed. After this period, it will be permanently deleted.
                        </div>
                    </div>
                }
            </div>
            <DialogFooter>
                <PrimaryButton onClick={closeDialog} text="Close" />
            </DialogFooter>
        </Dialog>

    return (
        requestSavedDialog
    )
}

export default DeletePowerAppConfirmationDialog;



// WEBPACK FOOTER //
// ./src/components/EditSite/PowerAppEditElements/DeletePowerAppConfirmationDialog.js